// @flow

import * as React from 'react';
import {useAccount, useLocation} from 'docs/data';
import {getLoginUrl} from 'docs/util';
import {Link} from './Link';

type LoginLinkProps = {|
  title?: string,
  id?: string,
  children?: React.Node,
|};

export const LoginLink = (props: LoginLinkProps) => {
  const {location} = useLocation();
  const {account} = useAccount();
  return (
    <Link
      href={getLoginUrl({
        account,
        returnUrl: location.toString(),
      })}
      {...props}
    />
  );
};
